/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { AgentStatus } from '../../../../modules/agent-availability/typings';

export const STATUS_COLORS = {
  [AgentStatus.ONLINE]: '#3F906D',
  [AgentStatus.OFFLINE]: '#7A7A7A',
};

interface StatusIndicatorProps {
  status: AgentStatus;
  size?: number;
  borderWidth?: number;
  borderColor?: string;
  position?: 'absolute' | 'relative' | 'static';
  bottom?: number;
  right?: number;
}

export const StatusIndicator = ({
  status,
  size = 12,
  borderWidth = 2,
  borderColor = '#fcfcfc',
  position = 'absolute',
  bottom = -1,
  right = -1,
}: StatusIndicatorProps) => {
  const isOffline = status === AgentStatus.OFFLINE;

  if (isOffline) {
    return (
      <div
        css={css({
          position,
          bottom: position === 'absolute' ? bottom : undefined,
          right: position === 'absolute' ? right : undefined,
          width: size,
          height: size,
          boxSizing: 'content-box',
          borderRadius: '50%',
          backgroundColor: STATUS_COLORS.OFFLINE,
          border: `${borderWidth}px solid ${borderColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <div
          css={css({
            width: size * 0.6,
            height: size * 0.6,
            borderRadius: '50%',
            backgroundColor: borderColor,
          })}
        />
      </div>
    );
  }

  return (
    <div
      css={css({
        position,
        bottom: position === 'absolute' ? bottom : undefined,
        right: position === 'absolute' ? right : undefined,
        width: size,
        height: size,
        boxSizing: 'content-box',
        borderRadius: '50%',
        backgroundColor: STATUS_COLORS[status],
        border: `${borderWidth}px solid ${borderColor}`,
      })}
    />
  );
};
